<div class="gt-routes-list-containerss">
    <div class="container" style="padding: 16px">

        <dx-data-grid id="projectFavList" #projectFavList keyExpr="id" [dataSource]="gridConnectionList"
            showBorders="true" class="gpd-datagrid" rowAlternationEnabled="true" [hoverStateEnabled]="true"
            (onRowClick)="onRowClick($event)" height="80vh" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
            [columnAutoWidth]="false" [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }"
            [width]="'100%'">
            <!--   <dxo-scrolling mode="standard"></dxo-scrolling> -->
            <dxo-paging [enabled]="false"> </dxo-paging>

            <dxo-header-filter [visible]="true"></dxo-header-filter>

            <dxo-toolbar>
                <dxi-item width="50%" location="before">
                    <dx-text-box
                        [(value)]="searchTerm"
                        mode="search"
                        valueChangeEvent="keyup"
                        width="100%"
                        class="custom-search-panel"
                        (onValueChanged)="projectFavList.instance.searchByText($event.value)"
                        i18n-placeholder="@@siteSearch"
                        placeholder="Site Search..."
                    ></dx-text-box>
                </dxi-item>
                <dxi-item width="50%" location="after">
                    <div class="gt-flex-dir-row">
                        <app-gpd-button class="gpd-button" icon="add" i18n-text="@@newSite" text="New Site"
                            (onClick)="startAddGridConnection()">
                        </app-gpd-button>
                        <!--                         <div style="width: 140px" class="gt-flex-width dx-field shift-favorites-switch-container">
                            <div class="dx-field-label" style="width: 60%;" i18n="@@favorites">Favorites</div>
                            <div class="dx-field-value"
                                style="width: 40%;justify-self: right;margin-right:0px;margin-left:auto;">
                                <dx-switch [(value)]="filterFavorites" (onValueChanged)="applyFavoritesFilter()"
                                    switchedOffText="" switchedOnText="">
                                </dx-switch>
                            </div>
                        </div> -->
                    </div>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column dataField="pipelineNr" i18n-caption="@@pipelineNumber" caption="Pipeline Number"></dxi-column>
            <dxi-column dataField="nr" i18n-caption="@@number" caption="Number"></dxi-column>
            <dxi-column dataField="name" i18n-caption="@@name" caption="Name"></dxi-column>

            <!-- <dxi-column [visible]="userIsAdmin" cellTemplate="buttonCellTemplate" width="68px" [formItem]="{visible: false}">
            </dxi-column>
            <div *dxTemplate="let item of 'buttonCellTemplate'">
                <div class="cell-with-buttons">
                    <div class="cell-button-container">
                        <dx-button icon="clear" class="cell-button" (onClick)="initDeleteLocation(item.data)">
                        </dx-button>
                    </div>
                </div>
            </div> -->


        </dx-data-grid>

        <!--         <div class="gt-bottom-page-button-container">
            <div class="gt-flex-width"></div>
            <div class="gt-flex-width gt-flex-dir-row-rev">
                <dx-button class="gt-button gt-primary gt-bottom gt-btn-right" i18n-text="@@newSiteCaps" text="NEW SITE" (onClick)="startAddGridConnection()">
                </dx-button>
            </div>
        </div> -->

        <!-- <dx-popup dragEnabled="true" resizeEnabled="true" [visible]="newGridConnectionPopupVisible" [width]="400"
            [title]="addText" height="fit-content" (onHiding)="newGridConnectionPopupVisible = false"> -->

        <!--             <div class="project-bottom-page-button-container">
                <div class="gt-flex">
                    <dx-button class="gt-button gt-tertiary gt-btn-right" i18n-text="@@abortCaps" text="ABORT"
                        (click)="newGridConnectionPopupVisible = false">
                    </dx-button>
                </div>
                <div class="gt-flex">
                    <dx-button (onClick)="submitForm(null)" class="gt-button gt-primary gt-btn-right" i18n-text="@@confirmCaps" text="CONFIRM"
                        [useSubmitBehavior]="false">
                    </dx-button>
                </div>
            </div> -->
        <!-- </dx-popup> -->
    </div>
</div>

<app-delete-popup [visible]="deletePopupVisible" i18n-message [message]="'Do you want to delete this Site?'"
    (onConfirm)="handleDeleteShowFolders($event)" (onAbort)="deletePopupVisible = false"></app-delete-popup>

<app-generic-popup
    [(visible)]="deleteFolderPopupVisible"
    [title]="deleteFolderTitle"
    [width]="'560px'"
    [leftButtons]="deleteFolderLeftButtons"
    [buttons]="deleteFolderButtons"
>
    <p class="gpd-popup-description">
        Do you want to remove all folders and files associated with this site? If you choose to keep these
        folders/files, they will be automatically associated to any future sites that share the same name as the
        site you are removing.
    </p>
</app-generic-popup>


<app-generic-popup
    [(visible)]="newGridConnectionPopupVisible"
    [title]="addText"
    [width]="'500px'"
    [buttons]="newSitePopupButtons"
>
    <dx-form #newGridConnectionForm id="form" class="gpd-form" validationGroup="newGridData" [colCount]="1" labelLocation="top" [showColonAfterLabel]="false">
        <dxi-item name="Pipeline Nr." [isRequired]="true">
            <dxo-label i18n-text="@@pipelineNr" text="Pipeline Nr."></dxo-label>
            <dx-text-box [(value)]="newGridConnection.pipelineNr" [maxLength]="20">
                <dx-validator validationGroup="newGridData">
                    <dxi-validation-rule type="required" i18n-message="@@pipelineNrIsRequired"
                        message="Pipeline-Nr is required">
                    </dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </dxi-item>

        <dxi-item name="Name" [isRequired]="true">
            <dxo-label i18n-text="@@name" text="Name"></dxo-label>
            <dx-text-box [(value)]="newGridConnection.name" [maxLength]="45">
                <dx-validator validationGroup="newGridData">
                    <dxi-validation-rule type="required" i18n-message="@@nameIsRequired" message="Name is required">
                    </dxi-validation-rule>
                    <dxi-validation-rule type="pattern" pattern="^[a-zA-ZäöüÄÖÜß0-9_ \-\(\)\[\]\{\}]+$"
                        i18n-message="@@siteNamePatternValidation"
                        message="Name can only contain letters, numbers, underscores and hyphens">
                    </dxi-validation-rule>
                    <dxi-validation-rule type="stringLength" [min]="3" [max]="45"
                        i18n-message="@@siteNameLengthValidation"
                        message="Name must be between 3 and 45 characters">
                    </dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </dxi-item>
    </dx-form>
</app-generic-popup>